var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNasdaqs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 155,
    height: 44,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h15.027v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 .016h27V33H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M0 0h27v33.797H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.297 33.328c-5.293 0-8.582-3.066-8.582-8.008 0-5.129 3.035-8.32 7.922-8.32h.41c.613 0 1.457.02 2.61.164v-6.191h3.452V32.77s-3.28.558-5.812.558m-.031-13.61c-3.344 0-4.97 1.805-4.97 5.516 0 3.332 1.962 5.403 5.114 5.403.606 0 1.3-.04 2.246-.121V19.94c-.945-.152-1.707-.222-2.39-.222m-47.254 13.11l-9.325-16.273-.003 16.273h-3.25V12.227h4.55l9.325 16.128-.004-16.128h3.293v20.601zm29.703.317c-1.57 0-3.207-.176-5.156-.551l-.211-.04v-2.878l.308.066c1.719.367 3.203.68 4.688.68 1.199 0 3.992-.188 3.992-1.953 0-1.48-1.93-1.852-3.48-2.149l-.098-.02c-.29-.054-.563-.109-.793-.167-2.274-.59-4.7-1.477-4.7-4.524 0-2.972 2.352-4.675 6.454-4.675 1.969 0 3.398.21 4.547.382l.558.082v2.793l-.297-.054c-1.3-.239-2.824-.485-4.289-.485-1.629 0-3.562.305-3.562 1.754 0 1.203 1.582 1.547 3.414 1.946 2.562.554 5.738 1.25 5.738 4.746 0 3.207-2.59 5.047-7.113 5.047m33.085 0c-3.573 0-6.882-.63-6.882-5.192 0-4.965 5.117-4.965 8.176-4.965.304 0 1.742.067 2.183.086-.004-2.785-.039-3.449-4.078-3.449-1.601 0-3.379.316-4.949.598l-.3.054v-2.75l.202-.043c1.82-.37 3.575-.55 5.364-.55 3.914 0 7.23.394 7.23 5.25v10.59l-.238.027c-2.711.304-4.863.344-6.707.344m1.207-7.7c-2.95 0-4.778.434-4.778 2.594 0 2.5 2.332 2.707 4.52 2.707.816 0 2.285-.105 2.734-.137v-5.078c-.632-.027-2.277-.086-2.476-.086m-49.645 7.7c-3.578 0-6.886-.63-6.886-5.192 0-4.965 5.117-4.965 8.175-4.965.305 0 1.746.067 2.188.086-.004-2.785-.043-3.449-4.082-3.449-1.602 0-3.38.316-4.95.598l-.3.054v-2.75l.207-.043a26.55 26.55 0 0 1 5.36-.55c3.913 0 7.23.394 7.23 5.25v10.59l-.239.027c-2.71.304-4.863.344-6.703.344m1.203-7.7c-2.949 0-4.773.434-4.773 2.594 0 2.5 2.328 2.707 4.516 2.707.82 0 2.289-.105 2.738-.137v-5.078c-.637-.027-2.281-.086-2.48-.086",
    fill: "#231F20",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(139 16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.492 23.828V17.07c-1.347.188-2.062.188-2.64.188-1.368 0-2.887-.297-4.063-.793C2.156 15.37.586 12.59.586 9.023c0-1.78.434-5.035 3.336-6.789C5.379 1.364 7.098.992 9.684.992c.925 0 2.175.07 3.382.14l1.961.102v21.028l-3.535 1.566zM9.426 3.711C5.918 3.71 4.14 5.5 4.14 9.023c0 4.536 2.652 5.489 4.882 5.489.543 0 1.153 0 2.504-.172V3.809c-1.058-.07-1.547-.098-2.101-.098z",
    fill: "#231F20",
    fillRule: "nonzero",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.012.016L2.594 31.386a2.19 2.19 0 0 1-1.836 1.427v.015h12.07c.945 0 1.754-.601 2.055-1.441L26.305.016H14.012z",
    fill: "#0996C7",
    fillRule: "nonzero",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.773 32.352c.7 0 1.313-.348 1.688-.875.039-.055.176-.247.273-.508l4.188-11.512-2.45-6.723a2.07 2.07 0 0 0-3.597-.398c-.04.055-.203.3-.273.508l-4.188 11.508 2.461 6.75a2.067 2.067 0 0 0 1.898 1.25",
    fill: "#0996C7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.668.984H14.465c-.945 0-1.754.598-2.059 1.442L.988 33.796h12.293L24.7 2.427A2.187 2.187 0 0 1 26.668.988V.984z",
    fill: "#0996C7",
    fillRule: "nonzero",
    mask: "url(#f)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNasdaqs);
export default __webpack_public_path__ + "static/media/nasdaqs.e2742cbbaf7ce5c0db2e2ce4a53415a2.svg";
export { ForwardRef as ReactComponent };